export default {
  svgData: [
    {
      id: "slide3display1",
      name: "Display1",
      assets: [
        "https://cdn.scoutfeedback.com/gdot-workshop/general/Air+Quality+Main+GDOT+Brand_1.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/general/Air+Quality+Main+GDOT+Brand_2.jpg"
      ],
      label: "slide3display1"
    },
    {
      id: "slide3display2",
      name: "Display2",
      assets: [
        "https://cdn.scoutfeedback.com/gdot-workshop/general/noise-brochure-1.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/general/noise-brochure-2.jpg"
      ],
      label: "slide3display2"
    },
    {
      id: "slide3easel1",
      name: "Easel1",
      assets: [
        "https://cdn.scoutfeedback.com/gdot-workshop/general/NEPA+Poster+Green.jpg"
      ],
      label: "slide3easel1"
    },
    {
      id: "slide3easel2",
      name: "Easel2",
      assets: [
        "https://cdn.scoutfeedback.com/gdot-workshop/general/storm-water-board.jpg"
      ],
      label: "slide3easel2"
    },
    {
      id: "slide3avatar1"
    },
    {
      id: "slide3bubble1"
    }
  ],
  slideTitle: "Environmental",
  helpText: `
  <p class="text-justify help">Welcome to the Environmental Impacts station. In this space you
will find resources, displays, and documentation that highlight critical
environmental factors that are currently being evaluated for the
proposed SR 316 Bundle 2 Design-Build projects. We encourage you to
review the following displays in this space:</p>
<ul>
<li><blockquote>
<p class="text-justify help"><strong><u>Environmental Display</u></strong> – lists the
natural, cultural, and human environmental factors that must be
considered under the requirements of the National Environmental Policy
Act (NEPA)</p>
</blockquote></li>
<li><blockquote>
<p class="text-justify help"><strong><u>Stormwater Management Display</u></strong>, or
Municipal Separate Storm Sewer System (MS4) – highlights measures to
prevent water pollution</p>
</blockquote></li>
<li><blockquote>
<p class="text-justify help"><strong><u>Air Quality FAQ</u></strong> – general information
regarding air impacts</p>
</blockquote></li>
<li><blockquote>
<p class="text-justify help"><strong><u>Noise Brochure</u></strong> – general information
regarding noise and noise impacts</p>
</blockquote></li>
</ul>
<p class="text-justify help">If you have any questions, feel free to contact us directly at <a
href="mailto:P3Division@dot.ga.gov">P3Division@dot.ga.gov</a> or call
the project team at (404) 347-0185 (voicemail).</p>
<p class="text-justify help">We encourage you to visit the next station by clicking on the
right arrow or selecting your station of choice from the navigation
sidebar on the right. For additional information, click the following button <i class="mdi mdi-account-question" style="font-size:2em;"></i>   
    to learn about the specific station or the <i class="mdi mdi-information-outline" style="font-size:2em;"></i>to see this message again after you close it out. To return to the project website, 
    select the <i class="mdi mdi-exit-to-app" style="font-size:2em;"></i>icon.
    </p>`,
  aboutText: `
  <p class="text-justify help">Did you know the <a
  href="https://www.fhwa.dot.gov/federal-aidessentials/catmod.cfm?category=environm">National
  Environmental Policy Act (NEPA)</a> is a federal law that requires
  federal agencies to assess the environmental effects of their proposed
  actions prior to making decisions? NEPA directs federal agencies, when
  planning projects or issuing permits, to conduct environmental reviews
  to consider the potential impacts on the natural, human, and physical
  environments by their proposed actions. Avoidance and minimization of
  potential impacts to the environment are analyzed when considering
  proposed transportation projects such as the SR 316 Bundle 2
  Design-Build projects and proposed impact mitigation is included with
  the final NEPA approval. Under NEPA, an environmental document is
  required that identifies the significance of a project’s environmental
  impact.</p>
  <p class="text-justify help">In compliance with NEPA and within the draft environmental
  document currently under development, noise and air impacts are two of
  the effects that are studied for a transportation project. Georgia DOT
  measures potential noise and air impacts to residences, businesses, and
  other properties adjacent to the proposed project.</p>
  <p class="text-justify help">A Noise Impact Assessment or Noise Screening Assessment will be
  completed for every federal-aid highway project in the state of Georgia.
  The Georgia DOT Noise Abatement Policy provides engineers criteria for
  evaluating noise impacts.</p>
  <p class="text-justify help">An Air Assessment that considers a project’s impact on air
  quality will be completed for every federal-aid and state-funded
  transportation project. For federal-aid projects, the 1990 Clean Air Act
  (CAA), issued by the Environmental Protection Agency (EPA), sets forth
  guidelines to be followed by agencies responsible for attainment of the
  National Ambient Air Quality Standards (NAAQS).</p>
  
  `,
};

